export default {
  format: 'text/turtle',
  styles: {
    // for Bootstrap 4
    field: 'form-group row',
    fieldChild: 'card',
    label: 'col-sm-3 col-form-label text-center',
    inputColumn: 'col',
    input: 'form-control',
    inputGroup: 'input-group',
    inputGroupAppend: 'input-group-append',
    radio: 'form-check-input',
    radioGroup: 'form-check form-check-inline',
    radioLabel: 'form-check-label',
    button: 'btn btn-sm',
    buttonAdd: 'btn-primary btn-add-del',
    buttonDel: 'btn-danger btn-add-del',
    validInput: '',
    invalidInput: 'is-invalid',
    invalidFeedback: 'invalid-feedback'
  }
}
